import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge: (...inputs: string[]) => string = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-micro',
        'text-caption',
        'text-body',
        'text-body-lg',
        'text-heading-md',
        'text-heading',
        'text-heading-lg',
        'text-display-sm',
        'text-display',
        'text-display-lg',
        'text-display-xl',
      ],
      rounded: [
        'rounded-card',
        'rounded-control',
        'rounded-overlay',
        'rounded-item',
        'rounded-pill',
        'rounded-market-card-cover',
        'rounded-panel-inset',
        'rounded-panel-row',
        'rounded-overlay-item',
      ],
      // Custom box-shadow tokens must join the built-in `shadow` group so they
      // dedupe against `shadow-none` / `shadow-sm…` — otherwise tailwind-merge
      // can't tell `shadow-elevation-card` is a box-shadow and a consumer's
      // `shadow-none` fails to override a Panel's elevation (boxy-edge bug).
      shadow: [
        'shadow-elevation-flat',
        'shadow-elevation-inset',
        'shadow-elevation-card',
        'shadow-elevation-popover',
        'shadow-elevation-sticky',
        'shadow-elevation-modal',
        'shadow-elevation-overlay',
        'shadow-elevation-up',
        'shadow-glow-brand',
        'shadow-panel-brand-glow',
        'shadow-market-card-inset',
        'shadow-control-crisp',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
